import { Component, Input, OnInit } from '@angular/core';
import { MatSnackBar } from '@angular/material/snack-bar';
import { Clipboard } from '@angular/cdk/clipboard';
import { CommonService } from 'src/app/services/common.service';

@Component({
  selector: 'calsoft-safety-advice',
  templateUrl: './safety-advice.component.html',
  styleUrls: ['./safety-advice.component.scss']
})
export class SafetyAdviceComponent implements OnInit {

  constructor(
      private commonService:CommonService,
    private clipboard: Clipboard,
    private snackBar: MatSnackBar,
  ) { }

  ngOnInit(): void {
  }

  @Input() list: any;

  @Input() type: any=1;

  @Input() title: any;

  @Input() alcoholInteraction:any;
  @Input()PregnancyInteraction: any;
  @Input() BreastfeedingInteraction: any;
  @Input() DrivingInteraction: any;
  @Input() KidneyInteraction: any;
  @Input() LiverInteraction: any;

  facebook() {
    let url = 'https://www.facebook.com/sharer/sharer.php?u=' + encodeURIComponent(location.href)
    'facebook-share-dialog'
    this.commonService.goToLink(url)


  }

  whatsapp() {
    let currentURL = window.location.href
    let url = `https://web.whatsapp.com/send?text=${currentURL}`
    this.commonService.goToLink(url)

  }

  copy() {
    let currentURL = window.location.href
    this.clipboard.copy(`${currentURL}`);
    this.snackBar.open(`Copied `, '×', { panelClass: 'success', verticalPosition: 'bottom', duration: 3000 });
  }

}
